// @ai-generated 2026-08-27T08:12:58+00:00 by malte.ulfers@tngtech.com using Claude Opus 5 (1M context)
import type { ValidationOutcome } from '@utils/toolCallEnvelope';

/**
 * The validation commands that get a card of their own, declared the way `ENTITY_TOOLS` is: adding
 * one is a new entry here, with no rendering code to touch.
 */
export interface ValidationTool {
    name: string;
    title: string;
    /** Route of one record's detail frame, relative to the mandant subpath. */
    detailPath: (id: string) => string;
    /** Column header over the rejected records, e.g. "Auftrag". */
    entityLabel: string;
    /** Nominative plural, for "5 Aufträge geprüft". */
    plural: string;
    /** Dative plural, for "2 von 5 Aufträgen abgelehnt" — German needs both cases. */
    pluralDative: string;
}

export const VALIDATION_TOOLS: ValidationTool[] = [
    {
        name: 'orders.validate.v1',
        title: 'Kriterienprüfung Aufträge',
        detailPath: (id) => `orders/${id}`,
        entityLabel: 'Auftrag',
        plural: 'Aufträge',
        pluralDative: 'Aufträgen',
    },
    {
        name: 'addresses.validate.v1',
        title: 'Kriterienprüfung Adressen',
        detailPath: (id) => `stammdaten/addresses/${id}`,
        entityLabel: 'Adresse',
        plural: 'Adressen',
        pluralDative: 'Adressen',
    },
];

/** The card for a tool name, or undefined for a tool that is not a validation call. */
export function validationToolFor(toolName: string | undefined): ValidationTool | undefined {
    return toolName === undefined ? undefined : VALIDATION_TOOLS.find((tool) => tool.name === toolName);
}

/** A hard failure rejects the entity; a soft one only filters it out, so the two are named apart. */
export function summarizeValidation(outcome: ValidationOutcome, tool: ValidationTool): string {
    const rejected = outcome.hardFailed.length;
    const skipped = outcome.softFailed.length;
    const total = outcome.passedCount + rejected + skipped;

    if (rejected === 0 && skipped === 0) {
        return `${total} ${tool.plural} geprüft, alle bestanden`;
    }

    if (rejected === 0) {
        return `${skipped} von ${total} ${tool.pluralDative} übersprungen`;
    }

    const rejectedPhrase = `${rejected} von ${total} ${tool.pluralDative} abgelehnt`;
    return skipped === 0 ? rejectedPhrase : `${rejectedPhrase}, ${skipped} übersprungen`;
}
